import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

export class ScrollEnter {
  constructor() {
    this.DOM = {};
    this.DOM.items = document.querySelectorAll('[data-inview]');
    this.DOM.parallax = document.querySelectorAll('[data-parallax]');

    if (!this.DOM.items) return;

    this.init();
  }
  init() {

    this.DOM.items.forEach((item) => {
      // const name = item.getAttribute('data-inview');
      const option = {
        trigger: item,
        start: 'top bottom-=25%',
        once: true,
        // markers: true,
        onEnter: () => item.classList.add('is-enter')
      };

      ScrollTrigger.create(option);
    });


    this.DOM.parallax.forEach((item) => {
      const y = item.getAttribute('data-parallax');
      gsap.fromTo(
        item,
        {
          yPercent: y, // 下に要素の幅の3倍分移動
        },
        {
          yPercent: 0, // 上に要素の幅の3倍分移動
          ease: 'none', // イージングなし
          scrollTrigger: {
            trigger: item,
            start: 'top bottom',
            end: 'top top+=15%',
            scrub: 2, // 動作が遅くなる
            // markers: true,
          },
        }
      );

    });

  }
}
